import { CompilerComponent } from '@types';

import { block } from './block';
import { component } from './component';
import { defaultProps, protocolFactory } from './protocol';

export type BaseInputParts = 'base-input-label' | 'base-input-control';

export interface BaseInputProps {
  name: string;
  size: 'sm' | 'md' | 'lg';
  label: string;
  placeholder: string;
}

export default {
  block,
  component,
  defaultProps,
  protocolFactory,
} as CompilerComponent<BaseInputProps, BaseInputParts>;
